import React from "react";

const Response = props => <div className={props.colorClass}>{props.text}</div>;

export default Response;
